module.exports = __webpack_public_path__ + "img/4.95cc9e94.png";